import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const Facebook: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      d="M10.1639 9.27732V11.2224H7.86719V13.6234H10.1639V19.0335H12.882V13.6234H15.1981L15.4753 11.2237H12.882V9.27732C12.882 8.93339 13.1744 8.76207 13.2978 8.65645C13.5154 8.48384 14.5661 8.45679 14.5661 8.45679H15.5959V6.28116C15.0597 6.20671 14.519 6.16369 13.977 6.15234C10.0849 6.15234 10.1639 9.27732 10.1639 9.27732Z"
      stroke={color || '#FFF'}
      strokeMiterlimit="10"
    />
    <Path
      d="M16.6317 23.3274H6.83698C5.28943 23.3257 3.80572 22.6856 2.71143 21.5475C1.61714 20.4094 1.00165 18.8664 1 17.2569V7.07046C1.00165 5.461 1.61714 3.91795 2.71143 2.77989C3.80572 1.64183 5.28943 1.00171 6.83698 1H16.6317C18.1792 1.00171 19.6629 1.64183 20.7572 2.77989C21.8515 3.91795 22.467 5.461 22.4687 7.07046V17.2569C22.467 18.8664 21.8515 20.4094 20.7572 21.5475C19.6629 22.6856 18.1792 23.3257 16.6317 23.3274ZM6.83698 2.61793C5.70202 2.61964 4.61402 3.08929 3.81148 3.92394C3.00894 4.75858 2.55735 5.8901 2.5557 7.07046V17.2569C2.55735 18.4373 3.00894 19.5688 3.81148 20.4035C4.61402 21.2381 5.70202 21.7078 6.83698 21.7095H16.6317C17.7666 21.7078 18.8546 21.2381 19.6572 20.4035C20.4597 19.5688 20.9113 18.4373 20.913 17.2569V7.07046C20.9113 5.8901 20.4597 4.75858 19.6572 3.92394C18.8546 3.08929 17.7666 2.61964 16.6317 2.61793H6.83698Z"
      fill={color || '#FFF'}
    />
  </Svg>
);

export default Facebook;
